<template>
  <div style="width: 100%; height: 100%;">
    <canvas ref="chart" height="250"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import "chartjs-plugin-datalabels";
export default {
  name: "SurveyMultipleChoiceResults",
  props: {
    answers: { type: Array },
    isAnonymous: { type: Boolean, default: false }
  },
  data: () => ({ chart: null }),
  watch: {
    answers() {
      this.loadChart();
    }
  },
  computed: {
    labels() {
      return this.answers.map(x => x.answer);
    },
    datasets() {
      let max = this._.maxBy(this.answers, "count").count;
      return [
        {
          data: this.answers.map(x => x.count),
          backgroundColor: this.answers.map(x =>
            max == x.count
              ? this.$vuetify.theme.themes.light.success
              : this.$vuetify.theme.themes.light.lighttext
          )
        }
      ];
    }
  },
  mounted() {
    this.loadChart();
  },
  methods: {
    loadChart() {
      let self = this;
      let answerCount = this._.sumBy(this.answers, "count");
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new Chart(this.$refs.chart, {
        type: "horizontalBar",
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: {
          onClick: function(e) {
            if (self.isAnonymous) {
              return;
            }
            let activePoints = this.chart.getElementsAtEvent(e);
            let idx = activePoints[0]["_index"];
            let answer = self.answers[idx];
            self.$emit("answer", answer);
          },
          layout: { padding: { top: 5, bottom: 5, right: 50, left: 5 } },
          hover: { mode: null },
          legend: { display: false },
          tooltips: {
            enabled: false
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  fontSize: "14"
                }
              }
            ],
            xAxes: [
              {
                ticks: {
                  min: 0,
                  maxTicksLimit: 3
                },
                gridLines: {
                  display: true,
                  color: "transparent",
                  drawBorder: false,
                  zeroLineColor: this.$vuetify.theme.themes.light.lighttext,
                  zeroLineWidth: 1
                }
              }
            ]
          },
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              anchor: "end",
              align: "right",
              formatter: function(value) {
                return Math.round((value / answerCount) * 100) + "%";
              },
              font: {
                weight: "bold",
                size: "15"
              },
              color: this.$vuetify.theme.themes.light.lighttext
            }
          }
        }
      });
    }
  }
};
</script>
